<ng-content></ng-content>


// WEBPACK FOOTER //
// /mnt/e/apps/architect3/client/node_modules/@angular/material/list/typings/index.d.ts.MatSelectionList.html